import { Avatar, Box, Typography } from "@mui/material";
import { getUserData } from "server/security/utils";

const ProfileName = () => {
  const userData = getUserData();

  const username = userData ? userData.given_name + " " + userData.family_name : null;

  if (username?.length > 20) {
    return username?.slice(0, 15).concat(" ", "...");
  }

  return username ? (
    <Box sx={{ display: "flex", gap: 1, justifyContent: "center", alignItems: "center" }}>
      <Avatar src={userData.picture} />
      <Typography>{username}</Typography>
    </Box>
  ) : null;
};
export default ProfileName;
